// extracted by mini-css-extract-plugin
export default {"logo":"HeaderLogo_logo__wOgvw","dark-bg":"HeaderLogo_dark-bg__6kjJZ"};